import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formControl: {
        margin: theme.spacing(1),
    },
}));

export default function MunicipalitySearchForm(props) {
    const [labelWidth, setLabelWidth] = React.useState(0);
    const labelRef = React.useRef(null);
    const classes = useStyles();

    React.useEffect(() => {
        if (labelRef.current !== null) {
            setLabelWidth(labelRef.current.offsetWidth);
        }
    }, []);

    return (
        <div className={classes.container}>
            <table cellPadding="2">
                <tbody>
                    <tr>
                        <td>
                            <FormControl className={classes.formControl} variant="outlined">
                                <InputLabel ref={labelRef} htmlFor="MunicipalityName">
                                    Municipality Name
								</InputLabel>
                                <OutlinedInput
                                    id="MunicipalityName"
                                    onChange={(ev) => props.model.MunicipalityName = ev.target.value}
                                    labelWidth={labelWidth}
                                />
                            </FormControl>
                        </td>
                        <td>
                            <FormControl className={classes.formControl} variant="outlined">
                                <InputLabel ref={labelRef} htmlFor="CityName">
                                    City Name
								</InputLabel>
                                <OutlinedInput
                                    id="CityName"
                                    onChange={(ev) => props.model.CityName = ev.target.value}
                                    labelWidth={labelWidth}
                                />
                            </FormControl>
                        </td>
                        <td>
                            <FormControl className={classes.formControl} variant="outlined">
                                <InputLabel ref={labelRef} htmlFor="PostalCode">
                                    Postal Code
								</InputLabel>
                                <OutlinedInput
                                    id="PostalCode"
                                    onChange={(ev) => props.model.PostalCode = ev.target.value}
                                    labelWidth={labelWidth}
                                />
                            </FormControl>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
